// extracted by mini-css-extract-plugin
module.exports = {"separator":"separator_separator__2Z5VY"};